import { useEffect, useState } from "react";

export default function ShopHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <header className="relative w-full h-[45vh] min-h-[360px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/41a25b2815917146f70a5d7189525634.jpg"
          alt="PWA Shop"
          className="w-full h-full object-cover object-center transition-transform duration-[6000ms] ease-out"
          style={{ transform: loaded ? "scale(1)" : "scale(1.06)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
        <div className="absolute bottom-0 right-0 w-80 h-80 border-r border-b border-orange-500/12 pointer-events-none" />
      </div>

      <div className="absolute bottom-0 left-0 w-96 h-32 bg-orange-500/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 h-full flex flex-col justify-end pb-14 md:pb-20 px-6 md:px-16 lg:px-24 w-full">
        <div
          className={`inline-block bg-orange-500 text-white font-condensed font-bold text-xs uppercase tracking-widest px-3 py-1 mb-4 w-fit anim-hidden ${loaded ? "animate-fade-in-left" : ""}`}
        >
          Official Merchandise
        </div>
        <h1
          className={`font-condensed font-black text-white uppercase leading-none tracking-tight text-5xl md:text-7xl anim-hidden ${loaded ? "animate-fade-in-left delay-100" : ""}`}
        >
          PWA Shop
        </h1>
        <p
          className={`text-white/80 mt-3 text-sm md:text-base max-w-lg anim-hidden ${loaded ? "animate-fade-in-up delay-200" : ""}`}
        >
          Represent PWA in the streets, the gym, and the stands. Official gear, limited drops, and collector&apos;s items.
        </p>
      </div>
    </header>
  );
}
